export * from './language';
export * from './mixpanel';
export * from './robot';
export * from './storage';

// cookie domain
export const COOKIE_DOMAIN = ['pre', 'production', 'internet'].includes(import.meta.env.VITE_STAGE)
  ? window.location.hostname.endsWith('.gptbase.ai')
    ? '.gptbase.ai'
    : '.gbase.ai'
  : '';

// Widget Message Key
export const IFRAME_MESSAGE_OPEN = 'gptBaseWidgetOpened';
export const IFRAME_MESSAGE_CLOSE = 'gptBaseWidgetClose';

// Master Size
export const MASTER_SIZE = 'https://gbase.ai';

// widget footerBrand default value
export const WIDGET_FOOTER_DEFAULT_TEXT = 'Powered by GBase';

// checkout environment
export const PRODUCTION_STAGE_DEV = import.meta.env.VITE_STAGE === 'pre';
